<template>
  <div class="room-card" :class="cardClass" @click="onClick">
    <!-- 房间号和状态 -->
    <div class="room-header">
      <span class="room-number">{{ room.roomName }}</span>
      <span class="room-status">· {{ statusText }}</span>
    </div>
    
    <!-- 中间状态图标 -->
    <div class="room-icon">
      <i :class="statusIcon" v-if="!hasCustomer"></i>
      <span v-else class="customer-name">{{ room.customerInfo && room.customerInfo.name }}</span>
    </div>
    
    <!-- 底部信息 -->
    <div class="room-footer" v-if="hasCustomer">
      <div class="customer-info">
        <span class="project">{{ room.customerInfo && room.customerInfo.project }}</span>
        <span class="price">¥{{ room.customerInfo && room.customerInfo.price }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomCard',
  props: {
    room: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusText() {
      if (this.room.occupationStatus === '服务中') return '服务中';
      if (this.room.occupationStatus === '洗浴') return '洗浴';
      return this.room.status || '空闲';
    },
    statusIcon() {
      if (this.room.status === '维修中') return 'el-icon-warning';
      if (this.room.status === '停用') return 'el-icon-remove-outline';
      return 'el-icon-s-home';
    },
    hasCustomer() {
      return this.room.occupationStatus === '服务中' && this.room.customerInfo;
    },
    cardClass() {
      const status = this.room.occupationStatus || this.room.status;
      if (status === '服务中') return 'status-in-use';
      if (status === '洗浴') return 'status-bath';
      if (status === '维修中' || status === '停用') return 'status-unavailable';
      return 'status-available';
    }
  },
  methods: {
    onClick() {
      this.$emit('click', this.room);
    }
  }
}
</script>

<style scoped>
.room-card {
  width: 150px;
  height: 150px;
  border-radius: 5px;
  padding: 10px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.room-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
}

.room-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.room-icon {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}

.customer-name {
  font-size: 18px;
  font-weight: bold;
}

.room-footer {
  margin-top: 10px;
}

.customer-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.project {
  font-size: 14px;
}

.price {
  font-size: 14px;
  font-weight: bold;
}

/* 状态样式 */
.status-available {
  background-color: #67C23A;
  color: white;
}

.status-in-use {
  background-color: #409EFF;
  color: white;
}

.status-bath {
  background-color: #E6A23C;
  color: white;
}

.status-unavailable {
  background-color: #909399;
  color: white;
}
</style> 